import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

export const ProceedToCheckoutSection = styled(Box)`
  width: 100%;
  min-height: 40px;

  .cart__proceed-to-checkout--wrapper {
    width: 100%;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  @media screen and (max-width: 992px) {
    .cart__proceed-to-checkout--wrapper {
      width: 100%;
      top: auto;
      left: 0;
      bottom: 0;
      position: fixed;
      box-shadow: 0 0 4px 0 #CCCACA;
      z-index: 19;
      background: #ffffff;
      padding: 12px;
    }
  }
`

export const sampleDiv = styled.div``
